import { GET_CURRENT_USER_QUERY_KEY } from '@/hooks/api/users/useGetCurrentUser';
import { api } from '@/services/api';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { AuthService } from '../types';
import { useCompareCart } from '@/services/compareCart/useCompareCart';

export interface LocalAuthLoginCredentials {
  userId: string;
}

export interface LocalAuthService extends AuthService {
  login(credentials: LocalAuthLoginCredentials): Promise<void>;
}

const getCurrentAccessToken = (): string | undefined => {
  return localStorage.getItem('authToken') || undefined;
};

export const useLocalAuth = (): LocalAuthService => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { clearCart } = useCompareCart();

  const isAuthenticated = !!localStorage.getItem('authToken');

  const login = async (credentials: LocalAuthLoginCredentials) => {
    localStorage.setItem('authToken', credentials.userId);
    await queryClient.resetQueries({ queryKey: [GET_CURRENT_USER_QUERY_KEY] });
    await api.users.getCurrentUser();
    navigate('/tenants');
  };

  const logout = async () => {
    await queryClient.resetQueries({ queryKey: [GET_CURRENT_USER_QUERY_KEY] });
    localStorage.removeItem('authToken');
    clearCart();
    navigate('/signin');
  };

  return {
    authType: 'local',
    isAuthenticated,
    isLoading: false,
    login,
    logout,
    getCurrentAccessToken,
  };
};
